enum TaskType {
    Simple = "simple",
    MeasurementTrigger = "measurement_trigger",
    Contact = "contact",
    Acquisition = "acquisition",
    Organisation = "organisation",
    Consultation = "consultation",
    Read = "read",
    Appointment = "appointment",
    Observation = "observation",
    Inform = "inform",
    Measure = "measure",
    WarningToPrimaryTreatingPhysician = "warning_to_primary_treating_physician",
    Goal = "goal",
    Mailing = "mailing",
    Coaching = "coaching",
    Internal = "internal"
}

export {
  TaskType
};
